var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4444 5.55553H19.8889C20.1836 5.55553 20.4662 5.67259 20.6746 5.88097C20.8829 6.08934 21 6.37195 21 6.66664V18.8889L17.2967 15.8122C17.0968 15.6463 16.8453 15.5555 16.5856 15.5555H7.66667C7.37198 15.5555 7.08937 15.4385 6.88099 15.2301C6.67262 15.0217 6.55556 14.7391 6.55556 14.4444V11.1111M15.4444 5.55553V2.2222C15.4444 1.92751 15.3274 1.64489 15.119 1.43652C14.9106 1.22815 14.628 1.11108 14.3333 1.11108H2.11111C1.81643 1.11108 1.53381 1.22815 1.32544 1.43652C1.11706 1.64489 1 1.92751 1 2.2222V14.4444L4.70333 11.3666C4.90333 11.2022 5.15444 11.1111 5.41444 11.1111H6.55556M15.4444 5.55553V9.99997C15.4444 10.2947 15.3274 10.5773 15.119 10.7856C14.9106 10.994 14.628 11.1111 14.3333 11.1111H6.55556",
    stroke: "#2A2A2A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.aa66193c01b72ae4b6acc7eadfc43084.svg";
export { ForwardRef as ReactComponent };